// Recorrido abreviado (2da solicitud en adelante): qué pantallas se muestran
// y en qué orden lo decide consultasStatus.screens (GET /credit-application).
// `true` = mostrar la pantalla, `false` = saltarla; si ya no queda ninguna
// pantalla por delante se termina en /onboarding/finished.

export type RepeatScreen =
  | 'personal_data'
  | 'company_data'
  | 'shareholder_data'
  | 'shareholder_bureau_check'
  | 'ciec_consultation'
  | 'legal_representative_data'
  | 'document_upload'

export type RepeatScreens = Record<string, boolean>

const FINISHED_URL = '/onboarding/finished'

const PF_ORDER: Array<{ key: RepeatScreen; url: string }> = [
  { key: 'personal_data', url: '/onboarding/personal-data' },
  { key: 'ciec_consultation', url: '/onboarding/ciec-individual' },
  { key: 'document_upload', url: '/onboarding/documents' },
]

const PM_ORDER: Array<{ key: RepeatScreen; url: string }> = [
  { key: 'company_data', url: '/onboarding/company-data' },
  { key: 'shareholder_data', url: '/onboarding/majority-shareholder-data' },
  {
    key: 'shareholder_bureau_check',
    url: '/onboarding/personal-credit-bureau-consultation',
  },
  { key: 'ciec_consultation', url: '/onboarding/ciec' },
  { key: 'legal_representative_data', url: '/onboarding/legal-representative' },
  { key: 'document_upload', url: '/onboarding/documents' },
]

// Si el backend no manda consultasStatus se conserva el recorrido abreviado
// previo: solo datos (+ accionista y representante legal en PM) y documentos.
const LEGACY_SCREENS: RepeatScreens = {
  personal_data: true,
  company_data: true,
  shareholder_data: true,
  legal_representative_data: true,
  document_upload: true,
}

// Siguiente URL después de `current` (null = inicio del recorrido).
export function getNextRepeatUrl(
  current: RepeatScreen | null,
  isPFAE: boolean,
  screens: RepeatScreens | null
): string {
  const order = isPFAE ? PF_ORDER : PM_ORDER
  const effective = screens ?? LEGACY_SCREENS
  const start = current ? order.findIndex(s => s.key === current) + 1 : 0
  const next = order.slice(start).find(s => effective[s.key] === true)
  return next ? next.url : FINISHED_URL
}
